import React from 'react';

const PRESET_RATES = [4000, 4100, 4200, 4300];

const KhrRateCard = ({ rate, onChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-1">支付宝收款汇率</h3>
    <p className="text-sm text-gray-500 mb-4">
      收银台选择支付宝（KHR）收款时，USD 金额 × 汇率 = 实际收取瑞尔金额
    </p>
    <div className="flex items-center gap-4">
      <div className="flex-1">
        <label className="block text-sm font-medium mb-1">1 USD = ? KHR</label>
        <input
          type="number" min="100" max="10000" step="50"
          value={rate}
          onChange={e => onChange(parseInt(e.target.value) || 4200)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-lg font-medium"
        />
      </div>
      <div className="flex-shrink-0 pt-6">
        <div className="flex gap-2">
          {PRESET_RATES.map(r => (
            <button key={r}
              onClick={() => onChange(r)}
              className={`px-3 py-2 rounded-lg text-sm font-medium border transition-colors ${
                rate === r
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-white text-gray-600 border-gray-300 hover:border-blue-400'
              }`}>
              {r}
            </button>
          ))}
        </div>
      </div>
    </div>
    <div className="mt-3 p-3 bg-blue-50 rounded-lg">
      <p className="text-xs text-blue-600">
        示例：商品 $10.00 USD，按当前汇率收取
        <span className="font-bold ml-1">{(10 * (rate || 4200)).toLocaleString()} ៛</span>
      </p>
    </div>
  </div>
);

export default KhrRateCard;